import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Layout from "../component/layout";
import { getItem } from "../../../utils/localStorage";
import { makeRequest2 } from "../../../utils/makeRequest";
import { getWaterSensorSettingsURL } from "../../../utils/urls";

function MeterTypes() {
  const navigate = useNavigate();
  const [waterSensorEnabled, setWaterSensorEnabled] = useState(false);

  // Water Level Sensors only shows when the water_sensor service is enabled in Settings > Integrations
  useEffect(() => {
    const loadWaterSensorSetting = async () => {
      try {
        const facilityId = await getItem("selectedFacilityId");
        if (!facilityId) return;
        const response = await makeRequest2(getWaterSensorSettingsURL(facilityId), "GET");
        if (response?.success && response.data?.success) {
          setWaterSensorEnabled(Boolean(response.data.data?.enabled));
        }
      } catch (err) {
        console.error("Error loading water sensor setting:", err);
      }
    };
    loadWaterSensorSetting();
  }, []);

  const colClass = waterSensorEnabled ? "col-md-4" : "col-md-6";

  const handleMeterClick = (type) => {
    if (type === "water") {
      navigate("/facility/utility_management/meter_management/water_meters");
    } else if (type === "power") {
       navigate("/facility/utility_management/meter_management/power_meters");
    } else if (type === "tanks") {
      navigate("/facility/utility_management/meter_management/water_sensors");
    }
  };

  return (
    <Layout>
      <div className="page-header">
        <div className="page-block">
          <div className="row align-items-center">
            <div className="col-md-12">
              <ul className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to={"/facility/"}>Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="#">Meters Management</Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div className="card">
        <div className="card-body">
          <div className="row">
            {/* Water Meter Card */}
            <div className={colClass}>
              <div className="pc-component">
                <div className="card mb-2 text-center" style={{ position: "relative" }}>
                  <span className="badge bg-light-primary">
                    <i className="ti ti-droplet f-50 mt-3"></i>
                  </span>
                  <div
                    className="card-body"
                    onClick={() => handleMeterClick("water")}
                    style={{ cursor: "pointer" }}
                  >
                    <h5 className="card-title">Water Meters</h5>
                    <p className="card-text">
                      <span className="badge bg-light-primary">
                        Manage Water Meters
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Power Meter Card */}
            <div className={colClass}>
              <div className="pc-component">
                <div className="card mb-2 text-center" style={{ position: "relative" }}>
                  <span className="badge bg-light-primary">
                    <i className="ti ti-recharging f-50 mt-3"></i>
                  </span>
                  <div
                    className="card-body"
                    onClick={() => handleMeterClick("power")}
                    style={{ cursor: "pointer" }}
                  >
                    <h5 className="card-title">Power Meters</h5>
                    <p className="card-text">
                      <span className="badge bg-light-primary">
                        Manage Power Meters
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Water Level Sensors Card (water_sensor service) */}
            {waterSensorEnabled && (
              <div className={colClass}>
                <div className="pc-component">
                  <div className="card mb-2 text-center" style={{ position: "relative" }}>
                    <span className="badge bg-light-primary">
                      <i className="ti ti-ripple f-50 mt-3"></i>
                    </span>
                    <div
                      className="card-body"
                      onClick={() => handleMeterClick("tanks")}
                      style={{ cursor: "pointer" }}
                    >
                      <h5 className="card-title">Water Level Sensors</h5>
                      <p className="card-text">
                        <span className="badge bg-light-primary">
                          Manage Water Level Sensors
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </Layout>
  );
}

export default MeterTypes;
